/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                $mobMenu = $('#mobile-overlay-menu');

                $('header button.navbar-toggle').click(function () {
                    $mobMenu.toggle();
                });

                $mobMenu.find('.close').click(function () {
                    $mobMenu.toggle();
                });



            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

                setTimeout(function () {
                    $('.page-loader .loader-inner').fadeOut(200, function () {
                        $('.page-loader').fadeOut(200);
                    });
                }, 300);

                helpers.cptListAsCarousel('.cpt-list-partenaires');
                helpers.cptListAsCarousel('.cpt-list-rfrences');

                helpers.wpcf7();
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

//helpers
var helpers = (function ($) {

    //export
    return {
        cptListAsCarousel: function (listSelector) {
            function fitLiContent() {
                setTimeout(function () {
                    $partArticlesHeader = $(listSelector).find('article header');
                    $partArticlesHeader.height($partArticlesHeader.width());
                }, 300);
            };
            fitLiContent();

            var $owl = $(listSelector).find("ul").owlCarousel({
                loop: true,
                autoplay: true,
                autoheight: true,
                responsive: {
                    0: {
                        items: 2
                    },
                    768: {
                        items: 3
                    },
                    1200: {
                        items: 4
                    }
                },
                onResize: fitLiContent
            });
        },
        wpcf7: function(){
          //wpcf7
          $('.wpcf7-form').prepend($('div.wpcf7-response-output'));
        }

    };
})(jQuery);
